import styled from 'styled-components';
import theme from '../../../../styles/defaultTheme';

export const CustomStatusTagContainer = styled.div`
	width: 86px !important;
	min-height: 20px !important;
	border-radius: 10px;
	text-align: center;
	font-size: ${theme.font.size12};
	font-weight: bold;
	margin: 0;
	background: ${(props) => props.backgroundStatus} 0% 0% no-repeat padding-box;
	color: ${(props) => props.colorStatus};
	border: solid 1px ${(props) => props.borderWhite};
`;
